export const ADMIN_ROLE_ID = 1;
export const ADMIN_USER_ID = 1;